<template>
    <div>
        <div id="seat-number">
            <div>
                <div class="coach">
                    <div class="layout">
                        <div class="seat-row">
                            <div class="driver-seat">Driver</div>
                        </div>

                        <div class="seat-row" v-for="(seat, index) in seats" :key="seat.id">

                            <div v-if="index === 6">
                                <div class="two-seats"><i class="material-icons">local_cafe</i></div>
                                <div class="an-aisle">{{ index+1 }}</div>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[1])" class="a-seat" :class="selectedClass(seat[1])">{{ seat[1] }}</li>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[0])" class="a-seat" :class="selectedClass(seat[0])">{{ seat[0] }}</li>
                            </div>
                            <div v-else-if="index === 7">
                                <div class="two-seats"><i class="material-icons">wc</i></div>
                                <div class="an-aisle">{{ index+1 }}</div>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[1])" class="a-seat" :class="selectedClass(seat[1])">{{ seat[1] }}</li>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[0])" class="a-seat" :class="selectedClass(seat[0])">{{ seat[0] }}</li>
                            </div>
                            <div class="last" v-else-if="index === seats.length-1">
                                <li :key="seat.id" @click="updateSelectedSeat(seat[4])" class="a-seat" :class="selectedClass(seat[4])">{{ seat[4] }}</li>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[3])" class="a-seat" :class="selectedClass(seat[3])">{{ seat[3] }}</li>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[2])" class="a-seat" :class="selectedClass(seat[2])">{{ seat[2] }}</li>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[1])" class="a-seat" :class="selectedClass(seat[1])">{{ seat[1] }}</li>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[0])" class="a-seat" :class="selectedClass(seat[0])">{{ seat[0] }}</li>
                            </div>
                            <div v-else>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[3])" class="a-seat" :class="selectedClass(seat[3])">{{ seat[3] }}</li>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[2])" class="a-seat" :class="selectedClass(seat[2])">{{ seat[2] }}</li>
                                <div class="an-aisle">{{ index+1 }}</div>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[1])" class="a-seat" :class="selectedClass(seat[1])">{{ seat[1] }}</li>
                                <li :key="seat.id" @click="updateSelectedSeat(seat[0])" class="a-seat" :class="selectedClass(seat[0])">{{ seat[0] }}</li>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>



<script>
    export default {
        name: "coach-seat-layout",
        components: {},
        props: [
            'sale',
            'events'
        ],
        created() {

        },
        destroyed() {
        },
        mounted:function() {

            // console.log('in the post', this.sale.user_assets_group_id); 
            let self = this;
            axios
                .get('/account/coach/reserved-seats')
                .then(function (response) {
                    // console.log(response.data.status)
                    if (response.data.status === 'success') {
                        console.log(response.data.unavailable_seats);
                        self.unavailable_seats = response.data.unavailable_seats;
                    } else {
                    }
                })
        },
        data() {
            return {
                msg: self.msg,
                reserved_seats: self.reserved_seats,
                unavailable_seats: self.unavailable_seats,
                selectedSeat: self.selectedSeat ? self.selectedSeat : 0,
                seats: [
                        [1,2,3,4]
                        ,[5,6,7,8]
                        ,[9,10,11,12]
                        ,[13,14,15,16]
                        ,[17,18,19,20]
                        ,[21,22,23,24]
                        ,[25,26]
                        ,[27,28]
                        ,[29,30,31,32]
                        ,[33,34,35,36]
                        ,[37,38,39,40]
                        ,[41,42,43,44]
                        ,[45,46,47,48]
                        ,[49,50,51,52,53]
                ]
            }

        },
        methods: {
            reloadComponent() {

                // console.log('reloading')
                this.$forceUpdate()

            },
            updateSelectedSeat(seat) {

                let self = this;
                if ( !self.unavailable_seats.includes(seat) ) {
                    axios
                        .post('/account/coach/reserve-seat', {
                            user_assets_group_id: self.sale.user_assets_group_id,
                            seat: seat,
                            ticket_id: self.sale.ticket_id,
                            event_id: self.events[0].id,
                        })
                        .then(function (response) {
                            if (response.data.status === 'success') {


                                self.selectedSeat = seat
                                self.seats_unavilable = response.data.unavailable_seats
                                self.msg = response.data.msg
                                self.reserved_seats = response.data.reserved_seats
                                self.$emit('childToParent', seat);

                                toastr.success(response.data.msg);

                            } else {
                                toastr.error(response.data.msg);
                                self.unavailable_seats = response.data.unavailable_seats;
//                                self.seats_unavilable = response.data.unavailable_seats
//                                self.reloadComponent()
//                                self.unavailable_seats.push(seat);

                            }
                        })


                }
        
            },
            selectedClass(seat) {
                let selectedClass = '';

                console.log(this.unavailable_seats, 'selectedClass()');

                if ( this.selectedSeat === seat && !this.unavailable_seats.includes(seat)) {

                    selectedClass = 'selected'

                } else if (this.unavailable_seats.includes(seat)) {

                    selectedClass = 'unavailable'

                }

                return selectedClass
            }
        },
        computed: {
        }
    }
</script>

<style scoped>
    #seat-number .coach {
        border: solid 1px #a8a5a5;
        border-radius: 15px;
        margin: 5px;
        padding: 15px;
        background-color: #bdb9b9;
        overflow:auto;
        font-size:0.2em;
    }
    #seat-number .coach .layout .seat-row {
        float:left;
        margin-left:8px;
    }
    #seat-number .coach .layout .last .a-seat {
        margin-top:5px;
    }
    #seat-number .coach .layout .a-seat {
        background-color:#fff;
        border:solid 1px blue;
        border-radius:3px;
        margin:3px;
        padding:5px 0px;
        font-weight:bold;
        color: blue;
        font-size:5em;
        text-align: center;
        width:35px;
        cursor:pointer;
        list-style:none;
    }
    #seat-number .coach .layout .unavailable {
        background-color: #bdb9b9;
        cursor:not-allowed;
    }
    #seat-number .coach .layout .selected {
        background-color: green;
    }
    #seat-number .coach .layout .driver-seat {
        background-color:#ccc;
        border:solid 1px #aaa;
        border-radius:10px;
        margin:10px 3px;
        padding:9px 4px;
        font-weight:bold;
        color: blue;
        font-size:5em;
        -webkit-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        transform: rotate(-90deg);
    }
    #seat-number .coach .layout .two-seats {
        margin-top: 25px;
        margin-bottom: 16px;
        font-size: 5em;
        font-weight: bold;
    }
    #seat-number .coach .layout .two-seats i {
        font-size: 2em;
    }
    #seat-number .coach .layout .an-aisle {
        margin: 3px;
        padding: 10px 10px;
        font-weight: bold;
        font-size: 5em;
        color: blue;
        text-align: center;
    }

    /* Toast Notification */
    #snackbar {
        visibility: hidden;
        min-width: 250px;
        margin-left: -125px;
        background-color: #333;
        color: #fff;
        text-align: center;
        border-radius: 2px;
        padding: 16px;
        position: fixed;
        z-index: 10000;
        left: 50%;
        bottom: 30px;
        font-size: 17px;
    }

    #snackbar.show {
        visibility: visible;
        -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
        animation: fadein 0.5s, fadeout 0.5s 2.5s;
    }

    @-webkit-keyframes fadein {
        from {bottom: 0; opacity: 0;} 
        to {bottom: 30px; opacity: 1;}
    }

    @keyframes fadein {
        from {bottom: 0; opacity: 0;}
        to {bottom: 30px; opacity: 1;}
    }

    @-webkit-keyframes fadeout {
        from {bottom: 30px; opacity: 1;} 
        to {bottom: 0; opacity: 0;}
    }

    @keyframes fadeout {
        from {bottom: 30px; opacity: 1;}
        to {bottom: 0; opacity: 0;}
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/tickets/CoachSeatLayout.vue